export default __webpack_public_path__ + "static/freeCodeCamp-404-986b65460a39b608aac138e7a1b1d177.svg";